export default "\ntable {\n  width: 100%;\n}\n\n.row-pointer {\n  cursor: pointer;\n}\n\n";